var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.selectedIcon,{tag:"component",attrs:{"size":_vm.size,"color":_vm.setColor}})}
var staticRenderFns = []

export { render, staticRenderFns }